import { useQuery } from '@biletiniz/apollo';
import { RUSSIA_VISA_BOOKING_INFO_QUERY } from './gql';

export const useRussiaVisaBookingInfo = ({ session }) => {
  const russiaVisaBookingInfo = useQuery(RUSSIA_VISA_BOOKING_INFO_QUERY, {
    variables: {
      session,
    },
    fetchPolicy: 'no-cache',
    skip: !session,
  });
  return {
    russiaVisaBookingInfo: russiaVisaBookingInfo?.data?.russiaVisaBookingInfo,
    loadRussiaVisaBookingInfoError: russiaVisaBookingInfo?.error?.message,
    isLoadingRussiaVisaBookingInfo: russiaVisaBookingInfo.loading,
  };
};
